// removed by extract-text-webpack-plugin
module.exports = {"mobile-l":"640px","container":"_2xyo4PcZJ_ZsJQI5SxZxGI"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Banner/HeroBanner/TypeD/TypeDWrapper.css
// module id = 1399
// module chunks = 0